export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "symbol_Bo_blur"				: "assets/img/symbols/symbol_Bonus/symbol_Bo_blur_{q}.png",
    "symbol_Bo"						: "assets/img/symbols/symbol_Bonus/symbol_Bo_sprite_{q}.png",
    "symbol_R_blur"					: "assets/img/symbols/symbol_Bonus/symbol_R_blur_{q}.png",
    "symbol_R"						: "assets/img/symbols/symbol_Bonus/symbol_R_sprite_{q}.png",

    "background"					: "assets/img/reels/background_{q}.png",
    "reels_cover"					: "assets/img/reels/cover_{q}.png",
    "label"							: "assets/img/reels/label_{q}.png",
    "ring_left_win"					: "assets/img/reels/ring_left_win_{q}.png",
    "ring_right_win"				: "assets/img/reels/ring_right_win_{q}.png",
    "win27"							: "assets/img/winlines/win-27_{q}.png",
    "winframe"						: "assets/img/reels/win-frame_{q}.png",
    "winx2_label"					: "assets/img/reels/winx2_label_{q}.png",

    "bigwin_bg"						: "assets/img/bigwin/bigwin_bg_{q}.png",
    "bigwin_label"					: "assets/img/bigwin/bigwin_label_{q}.png",
    "megawin_label"					: "assets/img/bigwin/megawin_label_{q}.png",
    "bonus_label"					: "assets/img/bigwin/bonuswin_label_{q}.png",
    "supermegawin_label"			: "assets/img/bigwin/supermegawin_label_{q}.png",

    "freespins_text_label"			: "assets/img/bonus/freespins_text_label_{q}.png",
    "freespins_reels"				: "assets/img/bonus/freespins_reels_{q}.png",

    "wintable_1"					: "assets/img/wintable/background_2_{q}.png",
    "wintable_2"					: "assets/img/wintable/background_1_{q}.png",
    "infopage_3"					: "assets/img/info/infopage_{q}.png",

    "wintable_label_bg_small"		: "assets/img/wintable/win_frame_small_{q}.png",
    "wintable_label_bg_big"			: "assets/img/wintable/win_frame_big_{q}.png",
    "wt_bonus_fs"					: "assets/img/wintable/bonus_fs_{q}.png",
    "wt_bonus_x2"					: "assets/img/wintable/bonus_x2_{q}.png",
};


function add_winles_to_load() {
    for(var i = 0; i < 26; i++) {

        if(i == 13) {
            continue;
        }

        to_load['winline_' + i] = 'assets/img/winlines/winline_' + i + '_{q}.png';
    }
}

add_winles_to_load();

export const to_load_json_atlas = {
    "logo_anim_json": ["assets/img/reels/logo_anim_{q}.png", "assets/img/reels/logo_anim_{q}.json"],
    "symbol_Bonus_r_anim_json": ["assets/img/symbols/symbol_Bonus/symbol_Bonus_r_anim_{q}.png", "assets/img/symbols/symbol_Bonus/symbol_Bonus_r_anim_{q}.json"]
};

export const to_load_audio = {
    "win_line_symbol_Dollar"		: "assets/audio/win_Dollar.ogg",
    "win_line_symbol_Cherry"		: "assets/audio/win_Cherry.ogg",
    "win_line_symbol_Orange"		: "assets/audio/win_Orange.ogg",
    "win_line_symbol_Plum"			: "assets/audio/win_Plum.ogg",
    "win_line_symbol_Bell"			: "assets/audio/win_Bell.ogg",
    "win_line_symbol_Grape"			: "assets/audio/win_Grape.ogg",
    "win_line_symbol_Seven"			: "assets/audio/win_Seven.ogg",
    "win_line_symbol_Bar"			: "assets/audio/win_Bar.ogg",
    "win_line_symbol_Joker"			: "assets/audio/win_Joker.ogg",

    "reel_stop_joker_0"				: "assets/audio/symbol_Joker_1.ogg",
    "reel_stop_joker_1"				: "assets/audio/symbol_Joker_2.ogg",
    "reel_stop_joker_2"				: "assets/audio/symbol_Joker_3.ogg",

    "reel_stop_scatter_0"			: "assets/audio/symbol_Scatter_1.ogg",
    "reel_stop_scatter_1"			: "assets/audio/symbol_Scatter_2.ogg",
    "reel_stop_scatter_2"			: "assets/audio/symbol_Scatter_3.ogg",

    "reel_stop"						: "assets/audio/reel_Stop.ogg",

    "reel_0"						: "assets/audio/reel_Spin_1.ogg",
    "reel_1"						: "assets/audio/reel_Spin_2.ogg",
    "reel_2"						: "assets/audio/reel_Spin_3.ogg",

    "reel_fs_0"						: "assets/audio/reel_Spin_FS_1.ogg",
    "reel_fs_1"						: "assets/audio/reel_Spin_FS_2.ogg",
    "reel_fs_2"						: "assets/audio/reel_Spin_FS_3.ogg",

    "scatter_x2"					: "assets/audio/bonus_Scatter.ogg",
    "bonus_count"					: "assets/audio/bonus_FreeSpins_Counter.ogg",
    "bonus_start"					: "assets/audio/bonus_FreeSpins_Shake.ogg",
    "FS_START"						: "assets/audio/bonus_FreeSpins_Start.ogg",

    "win_x2"						: "assets/audio/win_Multiplier.ogg",

    "audio_bw"						: "assets/audio/bwin_BigWin.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'bigwin_fonts' : {
        'img':	'assets/img/fonts/font_bigwin.png',
        'xml':	'assets/img/fonts/font_bigwin.xml',
    },

    'freespin_font': {
        'img': 'assets/img/fonts/font_free-spins.png',
        'xml': 'assets/img/fonts/font_free-spins.xml'
    },

    'font_wintable': {
        'img': 'assets/img/fonts/font_wintable.png',
        'xml': 'assets/img/fonts/font_wintable.xml'
    }
};

import { madnes_set_audio_volume } from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config) {

    var vol = 1;

    if(typeof server_config["volume"]["bigWin"] !== "undefined")
    {
        vol = server_config["volume"]["bigWin"];
        madnes_set_audio_volume('audio_bw', vol);
    }

    if(typeof server_config["volume"]["buttonEffect"] !== "undefined")
    {
        vol = server_config["volume"]["buttonEffect"];
        madnes_set_audio_volume('button_click', vol);
    }

    if(typeof server_config["volume"]["spin"] !== "undefined")
    {
        vol = server_config["volume"]["spin"];

        madnes_set_audio_volume('reel_0', vol);
        madnes_set_audio_volume('reel_1', vol);
        madnes_set_audio_volume('reel_2', vol);
        madnes_set_audio_volume('reel_fs_0', vol);
        madnes_set_audio_volume('reel_fs_1', vol);
        madnes_set_audio_volume('reel_fs_2', vol);
    }

    if(typeof server_config['volume']['stopReel'] != "undefined")
    {
        vol = server_config['volume']['stopReel'];

        madnes_set_audio_volume('reel_stop', vol);
    }

    if(typeof server_config["volume"]["winAnim"] !== "undefined")
    {
        vol = server_config["volume"]["winAnim"];

        madnes_set_audio_volume('win_line_symbol_Dollar', vol);
        madnes_set_audio_volume('win_line_symbol_Cherry', vol);
        madnes_set_audio_volume('win_line_symbol_Orange', vol);
        madnes_set_audio_volume('win_line_symbol_Plum', vol);
        madnes_set_audio_volume('win_line_symbol_Bell', vol);
        madnes_set_audio_volume('win_line_symbol_Grape', vol);
        madnes_set_audio_volume('win_line_symbol_Seven', vol);
        madnes_set_audio_volume('win_line_symbol_Bar', vol);
        madnes_set_audio_volume('win_line_symbol_Joker', vol);

        madnes_set_audio_volume('win_x2', vol);
        madnes_set_audio_volume('scatter_x2', vol);
        madnes_set_audio_volume('FS_START', vol);
    }

    if(typeof server_config["volume"]["winCounter"] !== "undefined") {
        vol = server_config["volume"]["winCounter"];

        madnes_set_audio_volume('remittance_A', vol);
        madnes_set_audio_volume('remittance_B', vol);
        madnes_set_audio_volume('bonus_count', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds1"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds1"];

        madnes_set_audio_volume('coins_loop', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds2"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds2"];

        madnes_set_audio_volume('bonus_start', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds3"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds3"];

        madnes_set_audio_volume('reel_stop_joker_0', vol);
        madnes_set_audio_volume('reel_stop_joker_1', vol);
        madnes_set_audio_volume('reel_stop_joker_2', vol);
        madnes_set_audio_volume('reel_stop_scatter_0', vol);
        madnes_set_audio_volume('reel_stop_scatter_1', vol);
        madnes_set_audio_volume('reel_stop_scatter_2', vol);
    }

}